/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — main booking route; provides the initial empty
 *              `dispos` shape and resets all booking-flow state on entry
 *   extends:   Route (@ember/routing/route)
 *   template:  none
 *   model:     returns `{ dispos: { contacts: [], products: [] } }`
 *   key:       model, setupController (resets bookConfirmed/showMenu/people/
 *              waitListNotes/hidePartecipoIo/add_younger/dateCalendar)
 *   uses:      -
 *   siblings:  controllers/index.js, templates/index.hbs
 *   tests:     route-hooks-test.js
 *
 * Entry route for the core booking flow: hands the controller an empty
 * dispos placeholder (real availability data is fetched by the controller's
 * own loadDataTask) and clears any leftover per-session booking state.
 */
import Route from '@ember/routing/route';
import { set } from '@ember/object';

export default class IndexRoute extends Route {
  model() {
    return {
      dispos: {
        contacts: [],
        products: [],
      },
    };
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    set(controller, 'bookConfirmed', null);
    set(controller, 'showMenu', null);
    set(controller, 'people', []);
    set(controller, 'waitListNotes', null);
    set(controller, 'hidePartecipoIo', false);
    set(controller, 'add_younger', false);
    set(controller, 'dateCalendar', new Date());
  }
}
